import TreatmentPlanDetails from './TreatmentPlanDetails';

export default TreatmentPlanDetails;
